import script from "./headCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./headCenter.vue?vue&type=script&setup=true&lang=js"

import "./headCenter.vue?vue&type=style&index=0&id=f5303b5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5303b5a"]])

export default __exports__